var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegrationFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#6e6edb",
    height: 48,
    rx: 4,
    width: 48
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fffffc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.838 24.702a.885.885 0 00-1.252 0l-2.028 2.028-2.288-2.288 2.028-2.028a.885.885 0 00-1.25-1.252l-2.03 2.03-1.88-1.88a.885.885 0 00-1.25 0l-1.918 1.917a6.918 6.918 0 00-.582 9.131l-2.958 2.96a.885.885 0 101.25 1.25l2.96-2.958a6.928 6.928 0 009.13-.582l1.919-1.918a.885.885 0 000-1.251l-1.88-1.88 2.029-2.028a.885.885 0 000-1.251zM37.455 10.545a.885.885 0 00-1.251 0l-2.96 2.959a6.936 6.936 0 00-9.13.581l-1.918 1.918a.885.885 0 000 1.251l8.55 8.55a.885.885 0 001.252 0l1.917-1.918a6.918 6.918 0 00.581-9.131l2.959-2.959a.885.885 0 000-1.251z"
  })))));
}
export default SvgIntegrationFill;